// extracted by mini-css-extract-plugin
module.exports = {"button":"styles_button__aPliO","label":"styles_label__V6g2V","icon":"styles_icon__wC29x"};